import React from 'react';
import FooterGlow from '../ui/footer-column';

const Footer = () => {
  return (
    <footer className="bg-[#f0ece1] text-brand-darkSage pt-16 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none z-0">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="w-full h-12 md:h-24">
          <path d="M0,0 C300,120 900,120 1200,0 L1200,120 L0,120 Z" fill="#f0ece1"></path>
        </svg>
      </div>
      
      <div className="relative z-10 mt-4">
        <FooterGlow />
      </div>
    </footer>
  );
};

export default Footer;